const ArticleScroll = () => {
  const body = document.body;

  if (body.classList.contains("single-post")) {
    const anchorLinks = body.querySelectorAll('a[href^="#"]');

    anchorLinks.forEach(anchor => {
      anchor.addEventListener('click', function(event) {
        event.preventDefault();
        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          const targetRect = targetElement.getBoundingClientRect();
          const offsetTop = window.scrollY + targetRect.top - 80;

          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
      });
    });
  }
}

export default ArticleScroll;
